<mat-card>
  <mat-card-header>
    <mat-card-title>Departments</mat-card-title>
    <mat-card-subtitle>Client departments</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <table
      mat-table
      [dataSource]="departments"
      class="mat-elevation-z8"
      aria-describedby="Admin, billing and clinical contacts"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let department">{{ department.name || 'N/A' }}</td>
      </ng-container>

      <ng-container matColumnDef="athena_department">
        <th mat-header-cell *matHeaderCellDef>Athena Department</th>
        <td mat-cell *matCellDef="let department">
          {{ department.athena_department_name || 'Not mapped' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let department">
          <button mat-icon-button color="accent" (click)="editDepartment(department)" matTooltip="Edit department">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteDepartment(department.id)" matTooltip="Remove department">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let department; columns: displayedColumns"></tr>
    </table>
  </mat-card-content>
  <mat-card-actions align="start">
    <button color="accent" mat-button (click)="showInput = true" *ngIf="!showInput">Add Department</button>
    <div *ngIf="showInput" class="department-input">
      <div class="department-form-row">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput [formControl]="nameDepartment" />
        </mat-form-field>

        <mat-form-field *ngIf="isAthenaClient">
          <mat-label>Athena Department</mat-label>
          <input
            matInput
            [formControl]="athenaDepartmentControl"
            [matAutocomplete]="athenaAuto"
            placeholder="Search Athena departments"
          />
          <mat-autocomplete
            #athenaAuto="matAutocomplete"
            [displayWith]="displayAthenaDepartment"
            (optionSelected)="onAthenaDepartmentSelected($event.option.value)"
          >
            <mat-option *ngIf="isSearchingAthena" disabled>
              <mat-spinner diameter="20"></mat-spinner>
              Searching...
            </mat-option>
            <mat-option
              *ngIf="!isSearchingAthena && athenaDepartments.length === 0 && athenaDepartmentControl.value?.length > 1"
              disabled
            >
              No departments found
            </mat-option>
            <mat-option *ngFor="let dept of athenaDepartments" [value]="dept">
              {{ dept.name }} (ID: {{ dept.departmentid }})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="department-form-actions">
        <button mat-icon-button color="accent" (click)="saveDepartment()" matTooltip="Save">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="cancelEdit()" matTooltip="Cancel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
